import axios from "@/axios";

const getDefaultState = () => ({
    token: null,
    user: null, 

});

const state = getDefaultState();

const mutations = {
    setToken(state, token) {
        state.token = token;
    },
    setUser(state, user) {
        state.user = user;
    },
    reset(state) {
        Object.assign(state, getDefaultState());
    }
};

const actions = {
    async login({ commit }, credentials) {
        try {
            // O seu novo endpoint já injeta o Cookie HTTP Only no navegador e devolve o JSON
            const response = await axios.post("/login", credentials);
            
            const token = response.data.access_token;
            const user = response.data.user;

            commit('setToken', token);
            commit('setUser', user);
            
        } catch (error) {
            console.error("Erro ao fazer login:", error);
            throw error;
        }
    },

    async logout({ commit }) {
        try {
            await axios.post("/logout");
        } catch (error) {
            console.error("Erro ao invalidar sessão no backend:", error);
        } finally {
            commit("reset");
            window.location.href = "/v2/login";
        }
    },

    /**
     * Tenta restaurar a sessão em memória (JWT) rodando um refresh silencioso usando o cookie.
     */
    async checkAuth({ commit, state }) {
        if (state.token) return true;

        try {
            const response = await axios.post("/refresh");
            const token = response.data.access_token;
            commit('setToken', token);

            // Busca os dados do usuário atualizados
            const userResponse = await axios.get("/usuario");
            commit('setUser', userResponse.data.user);
            return true;
        } catch (error) {
            commit("reset");
            return false;
        }
    }
};

const getters = {
    getToken(state) {
        return state.token;
    },
    isAuthenticated(state) {
        return !!state.token;
    },
    getUser(state) {
        return state.user;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
